import React from 'react';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { hooks } from 'farmx-redux-core';
import { getRanchEditUrl } from './editUrls';

const { useRanch } = hooks;
function RanchLink({ id }) {
  const ranch = useRanch(id);
  const { t } = useTranslation();
  if (!ranch) return null;
  return (
    <>
      <Link to={`/manage/sensor/?ranch=${ranch.name}`}>
        {`${ranch.name} [${ranch.id}]`}
      </Link>
      &nbsp;
      <Button href={getRanchEditUrl(id)} size="small">{t('Edit')}</Button>
    </>
  );
}

RanchLink.propTypes = {
  id: PropTypes.number.isRequired,
};

export default RanchLink;
